import axios from 'axios';
import { API_URL } from '../components/common/constants';

// Get user profile
export const getUserProfile = async () => {
  try {
    const token = localStorage.getItem('authToken');
    
    const response = await axios.get(`${API_URL}/user-profile`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

// Log report view
export const logReportView = async (reportData) => {
  try {
    const token = localStorage.getItem('authToken');
    
    const response = await axios.post(`${API_URL}/log-report-view`, reportData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error logging report view:', error);
    // Don't throw error - logging failure shouldn't break the app
    return null;
  }
};

// Update user profile
export const updateUserProfile = async (userData) => {
  try {
    const token = localStorage.getItem('authToken');
    
    const response = await axios.post(`${API_URL}/update-profile`, userData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

// Export other dashboard-related API functions
export default {
  getUserProfile,
  logReportView,
  updateUserProfile
};